import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import Parallax from '../../../common/Parallax'
import './index.scss'

const ServicesList = observer(() => {
  const content = ContentState.services?.services

  if (!content) return <></>

  return (
    <section className="services-list">
      <div className="services-list__title">{content.title}</div>
      {content.list.map((li: any, i: number) => (
        <div className="services-list__item" key={i}>
          <div className="services-list__item-img">
            <Parallax
              src={li.video.length ? li.video : li.img}
              type={li.video.length ? 'video' : 'img'}
              poster={li.img}
            />
          </div>
          <div className="services-list__item-col">
            <div className="services-list__item-top">
              <div className="services-list__item-icon">
                <img src={li.icon} />
              </div>
              <div className="services-list__item-title">{li.title}</div>
            </div>
            <div
              className="services-list__item-text"
              dangerouslySetInnerHTML={{ __html: li.text }}
            ></div>
          </div>
        </div>
      ))}
    </section>
  )
})

export default ServicesList
